/**
 * +presence: the session-facing side of shared-field presence (net/fieldPresence.ts). A session
 * (game/session.ts) calls these when `presenceHook.current` is set, i.e. while the world is in a
 * field or town with presence connected; otherwise nothing changes.
 *
 *   decorate  — before the frame's unit map is built: add other players (RenderUnits), their VFX
 *               events and animation cues, and invisible VFX target points (`frame.phantoms`);
 *   drainChat — zone chat lines since the last frame (the HUD's chat frame + speech bubbles);
 *   overlay   — after rendering: nameplates over the other players;
 *   say       — the player's own typed line goes to the zone (true = handled).
 */
import type { ContentRegistry, UnitId } from '@keystone/sim';
import type { ChatLine } from '../hud/chat/model';
import type { RenderFrame, Renderer } from '../render/types';

export interface PresenceSessionHook {
  decorate(frame: RenderFrame, content: ContentRegistry, now: number): void;
  drainChat(): ChatLine[];
  overlay(renderer: Renderer, focus: { x: number; y: number }, now: number): void;
  say(text: string, playerId: UnitId): boolean;
}

export const presenceHook: { current: PresenceSessionHook | null } = { current: null };
